export const PLAN_MAP = {
  BULLET: {
    code: '01',
    label: '一括返済方式',
  },
  FLAT_RATE_REVOLVING: {
    code: '02',
    label: '定額リボルビング方式',
  },
}

export const PLAN_LIST = [PLAN_MAP.BULLET, PLAN_MAP.FLAT_RATE_REVOLVING]
